// extracted by mini-css-extract-plugin
export default {"tabs":"tabs-rCmuT","tab":"tab-PnA6O","tabActive":"tabActive-NfTRd"};